(function () {
  'use strict';

  function initHeroSlideshow(root) {
    var track = root.querySelector('[data-hs-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hs-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hs-dot]'));
    var prevBtn = root.querySelector('[data-hs-prev]');
    var nextBtn = root.querySelector('[data-hs-next]');

    if (!track || slides.length === 0) return;

    var total = slides.length;
    var current = 0;
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var timer = null;
    var isEditorEditingThis = false;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Drag state
    var isPointerDown = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragDeltaX = 0;
    var trackWidth = 0;
    var DRAG_THRESHOLD = 8; // px before we treat it as a drag, not a click
    var SWIPE_THRESHOLD_RATIO = 0.15; // fraction of slide width to trigger a slide change

    function goTo(index, opts) {
      opts = opts || {};
      current = (index + total) % total;
      applyTransform(0, opts.silent ? false : true);

      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      slides.forEach(function (slide, i) {
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });

      if (!opts.silent) restartAutoplay();
    }

    function applyTransform(extraPx, animate) {
      track.style.transition = animate && !reducedMotion
        ? 'transform 0.55s cubic-bezier(0.65, 0, 0.35, 1)'
        : 'none';
      var basePx = -(current * trackWidth);
      track.style.transform = 'translateX(' + (basePx + extraPx) + 'px)';
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay || total <= 1 || reducedMotion || isEditorEditingThis) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      startAutoplay();
    }

    function updateTrackWidth() {
      trackWidth = track.getBoundingClientRect().width;
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.dataset.index, 10) || 0;
        goTo(idx);
      });
    });

    // Pause on hover / focus
    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', function () {
      if (!isPointerDown) startAutoplay();
    });
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', function () {
      if (!isPointerDown) startAutoplay();
    });

    // Pointer-based drag (covers mouse, touch, and pen in one code path)
track.addEventListener('pointerdown', function (e) {
  if (e.button !== undefined && e.button !== 0) return;
  if (e.target.closest('a, button')) return;
  isPointerDown = true;
  isDragging = false;
  dragStartX = e.clientX;
  dragDeltaX = 0;
  updateTrackWidth();
  stopAutoplay();
  try { track.setPointerCapture(e.pointerId); } catch (err) {}
});

    track.addEventListener('pointermove', function (e) {
      if (!isPointerDown) return;
      dragDeltaX = e.clientX - dragStartX;

      if (!isDragging && Math.abs(dragDeltaX) > DRAG_THRESHOLD) {
        isDragging = true;
        track.classList.add('is-dragging');
      }

      if (isDragging) {
        // Resist dragging past the first/last slide
        var atStart = current === 0 && dragDeltaX > 0;
        var atEnd = current === total - 1 && dragDeltaX < 0;
        var resisted = (atStart || atEnd) ? dragDeltaX * 0.35 : dragDeltaX;
        applyTransform(resisted, false);
      }
    });

    var wasDragging = false;

function endDrag(e) {
  if (!isPointerDown) return;
  isPointerDown = false;
  track.classList.remove('is-dragging');

  if (isDragging) {
    wasDragging = true;
    var ratio = dragDeltaX / trackWidth;
    if (ratio <= -SWIPE_THRESHOLD_RATIO) {
      next();
    } else if (ratio >= SWIPE_THRESHOLD_RATIO) {
      prev();
    } else {
      goTo(current);
    }
  } else {
    startAutoplay();
  }

  isDragging = false;
  dragDeltaX = 0;
}

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', function (e) {
      if (isPointerDown) endDrag(e);
    });

    // Prevent a dragged slide's link/button from firing a click
track.addEventListener('click', function (e) {
  if (wasDragging) {
    e.preventDefault();
    e.stopPropagation();
    wasDragging = false;
  }
}, true);

    // Keyboard support
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') next();
      if (e.key === 'ArrowLeft') prev();
    });

    window.addEventListener('resize', function () {
      updateTrackWidth();
      applyTransform(0, false);
    });

    // Shopify theme editor integration
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target.contains(root)) {
        updateTrackWidth();
        goTo(0, { silent: true });
      }
    });

    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(root)) {
        isEditorEditingThis = true;
        stopAutoplay();
      }
    });

    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target.contains(root)) {
        isEditorEditingThis = false;
        startAutoplay();
      }
    });

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest('[data-hs-slide]');
      if (slide && root.contains(slide)) {
        var idx = parseInt(slide.dataset.index, 10) || 0;
        isEditorEditingThis = true;
        stopAutoplay();
        goTo(idx, { silent: true });
      }
    });

    document.addEventListener('shopify:block:deselect', function (e) {
      if (root.contains(e.target)) {
        isEditorEditingThis = false;
        startAutoplay();
      }
    });

    updateTrackWidth();
    goTo(0, { silent: true });
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initHeroSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();